import axios from "axios";

const runtimeConfig = typeof window !== "undefined" ? window.MACJIT_CONFIG || {} : {};
const browserHost = typeof window !== "undefined" ? window.location.hostname : "";
const isBrowserLocal = browserHost === "localhost" || browserHost === "127.0.0.1";
const isBrowserDev = browserHost === "dev.macjit.com" || browserHost.includes("macjit-frontend-dev");
const productionBackendUrl = isBrowserDev ? "https://api-dev.macjit.com" : "https://api.macjit.com";
const rawApiBase = runtimeConfig.apiBase || process.env.REACT_APP_API_BASE || "";
const rawBackendUrl = runtimeConfig.backendUrl || process.env.REACT_APP_BACKEND_URL || "";
const unsafeLocalApi = !isBrowserLocal && /^http:\/\/(localhost|127\.0\.0\.1):8000/i.test(rawApiBase);
const unsafeLocalBackend = !isBrowserLocal && /^http:\/\/(localhost|127\.0\.0\.1):8000/i.test(rawBackendUrl);
const API_BASE = unsafeLocalApi ? `${productionBackendUrl}/api` : rawApiBase;
const configuredBackendUrl = unsafeLocalBackend ? productionBackendUrl : rawBackendUrl;

export const BACKEND_URL = configuredBackendUrl || API_BASE.replace(/\/api\/?$/, "");
export const API = API_BASE || `${BACKEND_URL}/api`;

export const backendUrl = (path = "") => {
  if (/^https?:\/\//i.test(path)) return path;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  if (BACKEND_URL) return `${BACKEND_URL.replace(/\/$/, "")}${cleanPath}`;
  if (/^https?:\/\//i.test(API)) return `${API.replace(/\/api\/?$/, "")}${cleanPath}`;
  if (typeof window !== "undefined" && window.location.port === "3000") return `https://api-dev.macjit.com${cleanPath}`;
  return cleanPath;
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mm_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  cfg.headers["X-Trace-Id"] = cfg.headers["X-Trace-Id"] || `ui-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return cfg;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 402 && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("macjit:subscribe-required", {
        detail: {
          message: error.response?.data?.detail || "You have reached your free trial limit. Subscribe now to continue.",
          code: error.response?.data?.code || "PAYMENT_REQUIRED",
        },
      }));
    }
    const detail = String(error?.response?.data?.detail || "");
    if (error?.response?.status === 400 && /storage is full/i.test(detail) && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("macjit:storage-full", {
        detail: {
          message: detail || "Storage is full. Contact admin to archive data or buy more storage.",
        },
      }));
    }
    return Promise.reject(error);
  }
);

export default api;

export const wsUrl = (token) => {
  if (!BACKEND_URL) {
    const proto = window.location.protocol === "https:" ? "wss" : "ws";
    return `${proto}://${window.location.host}/api/ws/${token}`;
  }
  const proto = BACKEND_URL.startsWith("https") ? "wss" : "ws";
  const host = BACKEND_URL.replace(/^https?:\/\//, "");
  return `${proto}://${host}/api/ws/${token}`;
};

export const STATUS_LABELS = {
  BOOKED: "Booked",
  CANCELLED: "Cancelled",
  ASSIGNED: "Assigned",
  IN_SERVICE: "In Service",
  READY_TO_TEST: "Ready to Test",
  READY_FOR_QA: "Ready to Test",
  QA_DONE: "QA Done",
  READY_FOR_BILL: "QA Done",
  QA_FAILED: "Returned to Mechanic",
  BILLED: "Billed",
  PAID: "Paid",
  REOPENED: "Reopened",
};

export const STATUS_ORDER = ["BOOKED", "ASSIGNED", "IN_SERVICE", "READY_TO_TEST", "QA_DONE", "BILLED", "PAID"];

export const STATUS_PROGRESS_ALIASES = {
  READY_FOR_QA: "READY_TO_TEST",
  READY_FOR_BILL: "QA_DONE",
  QA_FAILED: "ASSIGNED",
  REOPENED: "BOOKED",
};

export const normalizeProgressStatus = (status) => STATUS_PROGRESS_ALIASES[status] || status;
